import { CustomSelectorType } from "./constants";
import CustomSelector from "./CustomSelector";

export default class CustomRadio extends CustomSelector {
    constructor(props) {
        super({
            type: CustomSelectorType.RADIO,
            ...props,
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/components/customCheckbox/CustomRadio.js